export const CAPITAL_ALPHABET = [...Array(26)].map((val, i) => String.fromCharCode(i + 65))